import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectCurrentNote } from '../share/models';
import { IWorkspacesState, IWorkspaceInstance } from './workspaces.reducer';

export const selectWorkspaces = createFeatureSelector('workspaces');


export const selectAllWorkspaces = createSelector(
  selectWorkspaces,
  (workspaces: IWorkspacesState) => {
    if (workspaces
      && workspaces.entities
      && workspaces.entities.workspaces
    ) {
      return Object.values(workspaces.entities.workspaces);
    }
  }
);

export const selectAllAvailableWorkspaces = createSelector(
  selectAllWorkspaces,
  (workspaces) => {
    return workspaces.filter((workspace) => {
      const canEdit = !workspace.privileges || (workspace.privileges && workspace.privileges.indexOf('canEdit') != -1);
      return canEdit;
    })
  }
)

export const getSelectedWorkspaceId = createSelector(
  selectWorkspaces,
  (workspaces: IWorkspacesState) => {
    if(workspaces && workspaces.selectedWorkspaceId) {
      return workspaces.selectedWorkspaceId;
    }
  }
)

export const getIsWorkspacesFetched = createSelector(
  selectWorkspaces,
  (workspaces: IWorkspacesState) => {
    return !workspaces.isFetching;
  }
)

export const getCurrentNoteOrgWorkspace = createSelector(
  selectCurrentNote,
  selectAllAvailableWorkspaces,
  (note, workspaces) => {
    return workspaces.find((workspace) => workspace.globalId == note.workspaceId);
  }
)

export const getCurrentNoteOrgWorkspaces = createSelector(
  getCurrentNoteOrgWorkspace,
  selectAllAvailableWorkspaces,
  (noteWorkspace: IWorkspaceInstance, workspaces) => {
    if(!noteWorkspace) {
      return null;
    }
    return workspaces.filter((workspace) => (workspace.orgId.startsWith('u') && noteWorkspace.orgId.startsWith('u')) || workspace.orgId == noteWorkspace.orgId);
  }
)

export const getCurrentWorkspace = createSelector(
  selectCurrentNote,
  selectAllAvailableWorkspaces,
  (note, workspaces) => {
    return workspaces.find((workspace) => workspace.globalId == note.workspaceId);
  }
)


